import React, { useEffect, useRef, useState } from "react";
import SplitPane, {Pane} from "react-split-pane";
import PerfectScrollbar from "perfect-scrollbar";
import { TransformWrapper } from "react-zoom-pan-pinch";
import "./style.scss";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import Preview from "./preview";
import Controls from "./controls";
import useFullscreenStatus from "../../../customHooks/useFullscreenStatus";

const AdvancedPreview = (props) => {  
  const [zoomLevel, setZoomLevel] = useState(100);
  // serve per far refreshare il componente controls e ricalcolare l'area per attivare le frecce per scrollare
  const [isDragged, setIsDragged] = useState(false);

  const scrollerAreaRef = useRef();  
  const maximizeElemRef = useRef();
  const scrollerAreaPreview = useRef();

  let isFullscreen, setIsFullscreen;

  try {
    [isFullscreen, setIsFullscreen] = useFullscreenStatus(maximizeElemRef);      
  } catch (e) {    
    
    isFullscreen = false;
    setIsFullscreen = undefined;
  }

  const handleExitFullscreen = () => document.exitFullscreen();

  useEffect(() => {
    if (!scrollerAreaRef.current) return undefined;
    let ps = new PerfectScrollbar(scrollerAreaRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [scrollerAreaRef?.current]);

  return (
    <div style={props.style}>
      <SplitPane
        onChange={(size) => {
          setIsDragged(true);                                   
          document.querySelector(".Pane2").style.height = "calc(100% - "+ size + "px - 40px)";          
        }}

        split="horizontal" defaultSize={(window.innerHeight - 250) + "px"} minSize={"40px"} /*  maxSize={(window.innerHeight - 250) + "px"}*/ >
        <div ref={scrollerAreaRef} className="containerPane">
          <Pane className="contentDetail">
          
            {props.children}
          
          </Pane>
        </div>
        <Pane>
          <div className="previewAdvanceContainer" ref={maximizeElemRef}>
            <TransformWrapper
              onZoomStop={(e) => {
                setZoomLevel((e.state.scale * 100).toFixed(0));
              }}
              initialScale={1}
              minScale={0.1}
              maxScale={2}
              doubleClick={{
                disabled: true
              }}
              // wheel={{
              //   activationKeys: ["z"]
              // }}
              // panning={{
              //   activationKeys: ["x"],
              // }}
              limitToBounds={false}
              zoomAnimation={{ disabled: true }}
              initialPositionX={0}
              initialPositionY={0}
              onZoom={(e) => {
                setZoomLevel((e.state.scale * 100).toFixed(0));
              }}
              wheel={{disabled: true}}                   
            >              
              {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                <>                                    
                  <Preview 
                    scrollerAreaPreview={scrollerAreaPreview} 
                  />
                  <Controls isDragged={isDragged} 
                    scrollerAreaPreview={scrollerAreaPreview} 
                    handleExitFullscreen={handleExitFullscreen} 
                    isFullscreen={isFullscreen} 
                    setIsFullscreen={setIsFullscreen} 
                    zoomIn={zoomIn} 
                    zoomOut={zoomOut} 
                    zoomLevel={zoomLevel} 
                    setZoomLevel={setZoomLevel}
                    {...rest} />
                </>
              )}
               
            </TransformWrapper>
            
          </div>
        </Pane>
      </SplitPane>
    </div>
  );
};

export default AdvancedPreview;